/**
 * Official UTMify tracking script loader.
 * Injects the UTMify pixel/UTM parameter scripts once per page load.
 */

const UTM_SCRIPT_SRC = 'https://cdn.utmify.com.br/scripts/utms/latest.js'

export function loadUtmify(): void {
  if (typeof document === 'undefined') return
  if (document.querySelector(`script[src="${UTM_SCRIPT_SRC}"]`)) return

  const script = document.createElement('script')
  script.src = UTM_SCRIPT_SRC
  script.async = true
  script.defer = true
  script.setAttribute('data-utmify-prevent-xcod-sck', '')
  script.setAttribute('data-utmify-prevent-subids', '')
  document.head.appendChild(script)
}
